import { defineNuxtPlugin } from '#app/nuxt'
import { LazySvgoPaymentAmex, LazySvgoPaymentJcb, LazySvgoPaymentMastercard, LazySvgoPaymentUnionpay, LazySvgoPaymentUnknown, LazySvgoPaymentVisa, LazySvgoAwardMeal, LazySvgoCalendarCheckmark, LazySvgoCalendarClock, LazySvgoCalendar, LazySvgoCheckmarkCircleSolid, LazySvgoCheckmarkCircle, LazySvgoCheckmark, LazySvgoChevronDown, LazySvgoChevronLeft, LazySvgoChevronRight, LazySvgoClock, LazySvgoClose, LazySvgoCopy, LazySvgoDiamond, LazySvgoExclamationCircle, LazySvgoExternalLink, LazySvgoGlobe, LazySvgoGuests, LazySvgoImage, LazySvgoInfoCircle, LazySvgoLocation, LazySvgoLock, LazySvgoLogo, LazySvgoMap, LazySvgoMarriottBonvoyLogo, LazySvgoMarriottGlobe, LazySvgoMeetingRoom, LazySvgoPercent, LazySvgoPlus, LazySvgoSell, LazySvgoSpinner, LazySvgoUpdate, LazySvgoXmark, LazySvgoPlusLogo, LazyProseA, LazyProseBlockquote, LazyProseCode, LazyProseEm, LazyProseH1, LazyProseH2, LazyProseH3, LazyProseH4, LazyProseH5, LazyProseH6, LazyProseHr, LazyProseImg, LazyProseLi, LazyProseOl, LazyProseP, LazyProsePre, LazyProseScript, LazyProseStrong, LazyProseTable, LazyProseTbody, LazyProseTd, LazyProseTh, LazyProseThead, LazyProseTr, LazyProseUl, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["SvgoPaymentAmex", LazySvgoPaymentAmex],
["SvgoPaymentJcb", LazySvgoPaymentJcb],
["SvgoPaymentMastercard", LazySvgoPaymentMastercard],
["SvgoPaymentUnionpay", LazySvgoPaymentUnionpay],
["SvgoPaymentUnknown", LazySvgoPaymentUnknown],
["SvgoPaymentVisa", LazySvgoPaymentVisa],
["SvgoAwardMeal", LazySvgoAwardMeal],
["SvgoCalendarCheckmark", LazySvgoCalendarCheckmark],
["SvgoCalendarClock", LazySvgoCalendarClock],
["SvgoCalendar", LazySvgoCalendar],
["SvgoCheckmarkCircleSolid", LazySvgoCheckmarkCircleSolid],
["SvgoCheckmarkCircle", LazySvgoCheckmarkCircle],
["SvgoCheckmark", LazySvgoCheckmark],
["SvgoChevronDown", LazySvgoChevronDown],
["SvgoChevronLeft", LazySvgoChevronLeft],
["SvgoChevronRight", LazySvgoChevronRight],
["SvgoClock", LazySvgoClock],
["SvgoClose", LazySvgoClose],
["SvgoCopy", LazySvgoCopy],
["SvgoDiamond", LazySvgoDiamond],
["SvgoExclamationCircle", LazySvgoExclamationCircle],
["SvgoExternalLink", LazySvgoExternalLink],
["SvgoGlobe", LazySvgoGlobe],
["SvgoGuests", LazySvgoGuests],
["SvgoImage", LazySvgoImage],
["SvgoInfoCircle", LazySvgoInfoCircle],
["SvgoLocation", LazySvgoLocation],
["SvgoLock", LazySvgoLock],
["SvgoLogo", LazySvgoLogo],
["SvgoMap", LazySvgoMap],
["SvgoMarriottBonvoyLogo", LazySvgoMarriottBonvoyLogo],
["SvgoMarriottGlobe", LazySvgoMarriottGlobe],
["SvgoMeetingRoom", LazySvgoMeetingRoom],
["SvgoPercent", LazySvgoPercent],
["SvgoPlus", LazySvgoPlus],
["SvgoSell", LazySvgoSell],
["SvgoSpinner", LazySvgoSpinner],
["SvgoUpdate", LazySvgoUpdate],
["SvgoXmark", LazySvgoXmark],
["SvgoPlusLogo", LazySvgoPlusLogo],
["ProseA", LazyProseA],
["ProseBlockquote", LazyProseBlockquote],
["ProseCode", LazyProseCode],
["ProseEm", LazyProseEm],
["ProseH1", LazyProseH1],
["ProseH2", LazyProseH2],
["ProseH3", LazyProseH3],
["ProseH4", LazyProseH4],
["ProseH5", LazyProseH5],
["ProseH6", LazyProseH6],
["ProseHr", LazyProseHr],
["ProseImg", LazyProseImg],
["ProseLi", LazyProseLi],
["ProseOl", LazyProseOl],
["ProseP", LazyProseP],
["ProsePre", LazyProsePre],
["ProseScript", LazyProseScript],
["ProseStrong", LazyProseStrong],
["ProseTable", LazyProseTable],
["ProseTbody", LazyProseTbody],
["ProseTd", LazyProseTd],
["ProseTh", LazyProseTh],
["ProseThead", LazyProseThead],
["ProseTr", LazyProseTr],
["ProseUl", LazyProseUl],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
